import React, { Component } from 'react';
import UtilService from "../../services/util.service";

const PlanRental = ({message}) => {
    let data = message
    try {
        data = JSON.parse(data)
    }
    catch (e) {
        data = undefined
    }
    let  current_bill_plan = data && data['Current Bill Plan Benefits'] ? data['Current Bill Plan Benefits'] : data ? data : undefined
    let  viewDetailLink = UtilService.getPlatformWiseLinkForPlanDeatils();

    let benefit_object ={
        'Local':{
            class:'india',
            priority:1
        },
        'Local + STD':{
            class:'india',
            priority:1
        },
        'Internet':{
            class:'internet',
            priority:2
        },
        'SMS':{
            class:'sms',
            priority:6
        },
        'Roam. Out.':{
            class:'roaming',
            priority:4
        },
        'Roam. Inco.':{
            class:'roaming',
            priority:5
        },
        'Movies':{
            class:'airtel-tv',
            priority:8
        },
        'Music':{
            class:'wynk',
            priority:9
        },
        'Airtel Secure':{
            class:'secure',
            priority:7
        },
        'child':{
            class:'child',
            priority:3
        },
        'default':{
            class:'default',
            priority:20
        }
    }

    let sorted_benefits 
    if(current_bill_plan && current_bill_plan.benefits && current_bill_plan.benefits.length > 0){
        sorted_benefits = current_bill_plan.benefits.sort(function(a,b){
            if(benefit_object.hasOwnProperty(a.shortText) && benefit_object.hasOwnProperty(b.shortText)){
                return benefit_object[a.shortText].priority - benefit_object[b.shortText].priority
            }
            return 0
        })
    }
    
    return (<div >
        <div className="mr-20" style={{marginLeft:'60px',overflow:'auto'}}>
            <div className="rental-plan text-left pt-10 width-full data_balance_new">
                {!current_bill_plan && <p className=" color-white pt-10" style={{padding:'10px'}}>No plans to show</p>}
                {current_bill_plan && <div><span className=" pl-20 fs-9 color-white pt-10">Plan Rental</span>
                <p className="fs-20 pl-20 color-white pb-5">Rs. {current_bill_plan && current_bill_plan.price}</p>
                <ul>
                    {current_bill_plan && current_bill_plan.benefits && sorted_benefits && sorted_benefits.map((benefit,index)=>{

                        if(index < 3 && Object.keys(benefit).length > 0) {
                            
                            let displayText = "";
                            if(benefit) {
                                if(benefit.displayPackDescription && benefit.displayPackDescription === "4G/3G Internet") {
                                    displayText = `${benefit.quota ? benefit.quota : ""}${benefit.unit ? benefit.unit : ""} ${benefit.displayPackDescription ? benefit.displayPackDescription : ""}`;
                                } else {
                                    displayText = `${benefit.quota ? benefit.quota : ""} ${benefit.displayPackDescription ? benefit.displayPackDescription : ""}`;
                                }
                            }

                            return (
                            <li key={index}>
                                <span>
                                    <i className={`icons ${(benefit_object.hasOwnProperty(benefit.shortText)) ? benefit_object[benefit.shortText].class : benefit_object.default.class}`}/>
                                </span>
                                <p className="color-white fs-11 fs-light">{displayText}</p>
                            </li>
                            );
                            
                        }
                    })}
                </ul>
                <a href={viewDetailLink} target="_blank" className="display-block text-right color-white fs-11 pb-15 pr-10 fs-light">VIEW DETAILS &rsaquo;</a>
            </div>}

        </div>
        </div>
        </div>
    );
}

export default PlanRental;


// WEBPACK FOOTER //
// ./src/components/message-components/plan-rental.component.js